<script setup>
defineProps({
  // optional section heading rendered above the cloud
  title: { type: String, default: '' },
  // Array of [label, href]
  links: { type: Array, default: () => [] }
})
</script>

<template>
  <section class="block tight">
    <div class="wrap">
      <div class="sec-h"><h2>{{ title || 'Popular tools' }}</h2></div>
      <div class="cloud">
        <NuxtLink
          v-for="(link, i) in links"
          :key="i"
          :to="ftHref(link[1])"
        >{{ link[0] }}</NuxtLink>
      </div>
    </div>
  </section>
</template>
